<mat-toolbar>
    <span>Comentarios</span>
    <span class="spacer"></span>
</mat-toolbar>
<div class="p-5 bg-white w-full">
    <div class="flex pl-5 pr-5">
        <table class="tblComentarios">
            @for (item of listaComentarios; track $index) {
                <tr [class.campo-encontrado]="campos.includes(item.id)">
                    <td>
                        <p class="fecha-usuario">{{item.fecha | date : 'dd-MM-YYYY' }} {{item.usuario}}</p>
                        <p class="descripcion">{{item.descripcion}}</p>
                    </td>
                    <td class="button-actions">
                        <button mat-icon-button color="primary" (click)="edit($index, item)" class="p-1" [disabled]="item.desactivado || deshabilitado">
                            <mat-icon>edit</mat-icon>
                        </button>
                        <button mat-icon-button color="warn" (click)="delete($index, item)" class="p-1" [disabled]="item.desactivado || deshabilitado">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </td>
                </tr>
            }
        </table>
    </div>
    <form [formGroup]="formComentarios" (submit)="save()">
        <div class="flex-row p-5 pb-0">
            <mat-form-field class="w-1/3 mr-5">
                <mat-label>Fecha de comentario</mat-label>
                <input matInput [matDatepicker]="picker" [max]="moment().toDate()" formControlName="fecha">
                <!-- <mat-hint>DD/MM/YYYY</mat-hint> -->
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
                @if(formComentarios.controls["fecha"].hasError('required')) {
                    <mat-error>Campo obligatorio.</mat-error>
                }
            </mat-form-field>
            <mat-form-field class="w-full mr-5">
                <mat-label>Comentario</mat-label>
                <textarea matInput formControlName="descripcion" #comentario_descripcion maxlength="10000"></textarea>
                <mat-hint align="end">{{comentario_descripcion.value.length}} / 10000</mat-hint>
                @if(formComentarios.controls["descripcion"].hasError('required')) {
                    <mat-error>Campo obligatorio.</mat-error>
                }
                @if(formComentarios.controls["descripcion"].hasError('maxlength')) {
                    <mat-error align="end">{{formComentarios.controls["descripcion"].getError('maxlength').actualLength}} / {{formComentarios.controls["descripcion"].getError('maxlength').requiredLength}}</mat-error>
                }
            </mat-form-field>
        </div>

        <div class="flex p-5 pb-0 justify-start items-center">
            @if(editComentarios == null){
                <button mat-raised-button color="primary" type="submit" [disabled]="formComentarios.invalid || deshabilitado">AGREGAR</button>
            } @else {
                <button mat-stroked-button color="primary" type="button"(click)="resetForm()" class="mr-5">CANCELAR</button>
                <button mat-flat-button color="primary" type="submit" [disabled]="formComentarios.invalid">GUARDAR</button>
            }
        </div>
    </form>
</div>